export const GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD = "GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD"
export const GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR"

export const GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS = "GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS"
export const GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR"

export const GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS = "GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS"
export const GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR"
// camapign aggregated data for goal/quote_funnels
export const GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS = "GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS"
export const GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS = "GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS"
export const GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR = "GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR"

export const GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS = "GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS"
export const GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR"

export const GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS = "GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS"
export const GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR"

export const GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES = "GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES"
export const GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS = "GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS"
export const GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR = "GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR"

export const GET_QUOTE_FUNNELS_SOURCE_STATS = "GET_QUOTE_FUNNELS_SOURCE_STATS"
export const GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS = "GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS"
export const GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR = "GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR"